import { I18N_KEY_MISSING } from "../../thor.const";

export class TranslateCustomHandlerRessource {
    public static $inject: string[] = ["$log"];

    constructor($log: ng.ILogService) {
        return (key: string, lang: string) => {
            $log.warn("i18n key missing", { key, lang });
            return I18N_KEY_MISSING;
        };
    }
}
